//------------------------------------------------------------------------------
// ReportDistributionModal
//------------------------------------------------------------------------------
import React, { useState, useEffect } from "react";

import PropTypes from 'prop-types'
import { Button, Card, Col, DatePicker, Form, Input, InputNumber, Modal, Radio, Row, Select, Space, Switch, Typography } from 'antd'
const { Title, Text } = Typography
const { TextArea } = Input
const { Option } = Select;

import {
  MinusCircleOutlined,
  PlusOutlined,
} from '@ant-design/icons'

import Editor from '../../../elements/common/Editor'

const monthOptions = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];

const dayOptions = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const setPosOptions = ['First', 'Second', 'Third', 'Fourth', 'Last'];



const ReportSchedulingModal = ({
  isReportSchedulingModalOpen, 
  setIsReportSchedulingModalOpen,
  reportDefRef,
  width,
}) => {
  if (!reportDefRef.current) {  //Return if a reportDefRef object does not exist
    console.log('Bad or missing reportDefRef')
    return (<></>)
  }

  const [form] = Form.useForm();
  const schedule = reportDefRef.current
  const [scheduleValues, setScheduleValues] = useState(reportDefRef.current.schedule);


  const [frequency, setFrequency] = useState('YEARLY');
  const [yearlyMode, setYearlyMode] = useState('on');
  const [monthlyMode, setMonthlyMode] = useState('on');
  const [endOption, setEndOption] = useState('Never');
  const [summary, setSummary] = useState('');



  // useEffect(() => {
  //   form.setFieldsValue(scheduleValues);
  // }, [reportDefRef.current, isReportSchedulingModalOpen]);
  
  const handleCancel = () => {
    setIsReportSchedulingModalOpen(false)
  }
  
  const handleOk = () => {
    form.validateFields().then((values) => {
      let updatedDefRef = {...reportDefRef.current}
      updatedDefRef.schedule = values
      reportDefRef.current = updatedDefRef
      setIsReportSchedulingModalOpen(false)
      console.log('schedule.handleOk-result',reportDefRef.current,scheduleValues,updatedDefRef)
    });
  };
  // const handleOkWithSummary = () => {
  //   form.validateFields().then(values => {
  //     const summary = generateSummary(values);
  //     console.log('Schedule summary:', summary);
  //     handleOk(values, summary); // pass summary if needed
  //   });
  // };

  const generateSummary = (values) => {
    const { byMonth, byMonthDay, bySetPos, byDay, byMonthAlt, interval, count, until, endOption, frequency, byDay: weeklyDays } = values;
    let summary = `Every`;

    switch (frequency) {
      case 'YEARLY':
        if (yearlyMode === 'on') {
          summary += ` year on ${byMonth} ${byMonthDay}`;
        } else {
          summary += ` year on the ${bySetPos} ${byDay} of ${byMonthAlt}`;
        }
        break;
      case 'MONTHLY':
        if (monthlyMode === 'on') {
          summary += ` month on day ${byMonthDay}`;
        } else {
          summary += ` month on the ${bySetPos} ${byDay}`;
        }
        break;
      case 'WEEKLY':
        summary += ` ${interval || ''} week${interval > 1 ? 's' : ''} on ${weeklyDays?.join(', ') || 'N/A'}`;
        break;
      case 'DAILY':
        summary += ` ${interval || 1} day${interval > 1 ? 's' : ''}`;
        break;
      case 'HOURLY':
        summary += ` ${interval || 1} hour${interval > 1 ? 's' : ''}`;
        break;
      default:
        break;
    }

    if (endOption === 'After') {
      summary += `, ending after ${count} occurrences`;
    } else if (endOption === 'On Date' && until) {
      summary += `, until ${until.format('MMM D, YYYY')}`;
    }

    return summary;
  };

  useEffect(() => {
    form.validateFields().then(values => {
      setSummary(generateSummary(values));
    }).catch(() => {});
  }, [frequency, yearlyMode, monthlyMode, endOption]);

  return (

    <Modal
      title="Schedule Report"
      open={isReportSchedulingModalOpen}
      closable={false}
      keyboard={false}
      onCancel={handleCancel}
      onOk={handleOk}
      width={800}
    >
      <Form
        form={form}
        layout="horizontal"
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 18 }}
        onValuesChange={() => {
          form.validateFields().then(values => {
            setSummary(generateSummary(values));
          });
        }}
      >
        <Form.Item label="Repeat" name="frequency" initialValue="YEARLY">
          <Select onChange={val => setFrequency(val)}>
            <Option value="YEARLY">Yearly</Option>
            <Option value="MONTHLY">Monthly</Option>
            <Option value="WEEKLY">Weekly</Option>
            <Option value="DAILY">Daily</Option>
            <Option value="HOURLY">Hourly</Option>
          </Select>
        </Form.Item>

        {frequency === 'YEARLY' && (
          <>
            <Form.Item label="Mode">
              <Radio.Group value={yearlyMode} onChange={e => setYearlyMode(e.target.value)}>
                <Radio value="on">on</Radio>
                <Radio value="onThe">on the</Radio>
              </Radio.Group>
            </Form.Item>

            {yearlyMode === 'on' && (
              <Form.Item label="Date">
                <Space>
                  <Form.Item name="byMonth" noStyle initialValue="Jan">
                    <Select style={{ width: 100 }}>{monthOptions.map(month => <Option key={month} value={month}>{month}</Option>)}</Select>
                  </Form.Item>
                  <Form.Item name="byMonthDay" noStyle initialValue={1}>
                    <Select style={{ width: 80 }}>{Array.from({ length: 31 }, (_, i) => <Option key={i + 1} value={i + 1}>{i + 1}</Option>)}</Select>
                  </Form.Item>
                </Space>
              </Form.Item>
            )}

            {yearlyMode === 'onThe' && (
              <Form.Item label="Pattern">
                <Space>
                  <Form.Item name="bySetPos" noStyle initialValue="First">
                    <Select style={{ width: 100 }}>{setPosOptions.map(pos => <Option key={pos} value={pos}>{pos}</Option>)}</Select>
                  </Form.Item>
                  <Form.Item name="byDay" noStyle initialValue="Sunday">
                    <Select style={{ width: 100 }}>{dayOptions.map(day => <Option key={day} value={day}>{day}</Option>)}</Select>
                  </Form.Item>
                  of
                  <Form.Item name="byMonthAlt" noStyle initialValue="Jan">
                    <Select style={{ width: 100 }}>{monthOptions.map(month => <Option key={month} value={month}>{month}</Option>)}</Select>
                  </Form.Item>
                </Space>
              </Form.Item>
            )}
          </>
        )}

        {frequency === 'MONTHLY' && (
          <>
            <Form.Item label="Mode">
              <Radio.Group value={monthlyMode} onChange={e => setMonthlyMode(e.target.value)}>
                <Radio value="on">on</Radio>
                <Radio value="onThe">on the</Radio>
              </Radio.Group>
            </Form.Item>

            {monthlyMode === 'on' && (
              <Form.Item label="Day">
                <Form.Item name="byMonthDay" noStyle initialValue={1}>
                  <Select style={{ width: 80 }}>{Array.from({ length: 31 }, (_, i) => <Option key={i + 1} value={i + 1}>{i + 1}</Option>)}</Select>
                </Form.Item>
              </Form.Item>
            )}

            {monthlyMode === 'onThe' && (
              <Form.Item label="Pattern">
                <Space>
                  <Form.Item name="bySetPos" noStyle initialValue="First">
                    <Select style={{ width: 100 }}>{setPosOptions.map(pos => <Option key={pos} value={pos}>{pos}</Option>)}</Select>
                  </Form.Item>
                  <Form.Item name="byDay" noStyle initialValue="Sunday">
                    <Select style={{ width: 100 }}>{dayOptions.map(day => <Option key={day} value={day}>{day}</Option>)}</Select>
                  </Form.Item>
                </Space>
              </Form.Item>
            )}
          </>
        )}

        {frequency === 'WEEKLY' && (
          <Form.Item label="Days" name="byDay">
            <Select mode="multiple">
              {dayOptions.map(day => <Option key={day} value={day}>{day}</Option>)}
            </Select>
          </Form.Item>
        )}

        {frequency === 'DAILY' && (
          <Form.Item label="Every N Days" name="interval" initialValue={1}>
            <InputNumber min={1} />
          </Form.Item>
        )}

        {frequency === 'HOURLY' && (
          <Form.Item label="Every N Hours" name="interval" initialValue={1}>
            <InputNumber min={1} />
          </Form.Item>
        )}

        <Form.Item label="Ends" name="endOption" initialValue="Never">
          <Select onChange={val => setEndOption(val)}>
            <Option value="Never">Never</Option>
            <Option value="After">After</Option>
            <Option value="On Date">On Date</Option>
          </Select>
        </Form.Item>

        {endOption === 'After' && (
          <Form.Item label="Occurrences" name="count" initialValue={1}>
            <InputNumber min={1} />
          </Form.Item>
        )}

        {endOption === 'On Date' && (
          <Form.Item label="End Date" name="until">
            <DatePicker style={{ width: '100%' }} />
          </Form.Item>
        )}

        <Form.Item label="Summary">
          <Text type="secondary">{summary}</Text>
        </Form.Item>
      </Form>
    </Modal>  )
}

// ReportDistributionModal.propTypes = {
//   visible: PropTypes.bool.isRequired,
//   setVisible: PropTypes.func.isRequired
// }

export default ReportSchedulingModal;
